// Components
import { HelpText } from 'components/usersong/modalheader'

import styles from './introtooltip.css'

type IntroTooltipProps = {
  title: string
  subtitle?: string
  linkUrl?: string
  linkText?: string
}

const IntroTooltip = ({ title, subtitle, linkUrl, linkText }: IntroTooltipProps): JSX.Element => (
  <div className={styles.container}>
    <h3 className={styles.title}>{title}</h3>
    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    {linkUrl && linkText && <HelpText linkUrl={linkUrl} text={linkText} />}
  </div>
)

export default IntroTooltip
